// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fnBMy{padding:16px}.EYETJ{margin:0;transition:width .3s ease-in-out}.jVGFb{transition:width .3s ease-in-out}.OWVNd{margin-top:12px}.P96SA{align-items:center}.P96SA .n572E{flex:1}.T9xYj{margin-top:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popover": `fnBMy`,
	"form": `EYETJ`,
	"formColumn": `jVGFb`,
	"priceAfterDiscount": `OWVNd`,
	"includedServiceRow": `P96SA`,
	"includedServiceItem": `n572E`,
	"actions": `T9xYj`
};
export default ___CSS_LOADER_EXPORT___;
